import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { workAdvisoryKeys } from "@/lib/query-keys";
import { normalizeReportData } from "@/lib/workadvisory-report";
import type {
  WorkAdvisoryReviewReport,
  WorkAdvisoryReviewRow,
} from "@/types/workadvisory";

/** Todos los informes, borradores incluidos. Solo admin. */
export function useWorkAdvisoryReviewList() {
  return useQuery({
    queryKey: workAdvisoryKeys.reviewList(),
    queryFn: async () => {
      const res = await fetchToBackend<{ data: WorkAdvisoryReviewRow[] }>(
        "/admin/work-advisory/reports",
      );
      return res.data;
    },
  });
}

/** El informe que se está revisando, publicado o no. */
export function useWorkAdvisoryReviewReport(reportId?: number) {
  return useQuery({
    queryKey: workAdvisoryKeys.review(reportId),
    enabled: reportId !== undefined,
    queryFn: async () => {
      const res = await fetchToBackend<{ data: WorkAdvisoryReviewReport }>(
        `/admin/work-advisory/reports/${reportId}`,
      );
      return {
        ...res.data,
        workadvisoryreport_data: normalizeReportData(
          res.data.workadvisoryreport_data,
        ),
      };
    },
  });
}
